import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import MailSource from 'sources/inbox/MailSource';

class NavActions {
  constructor() {
    this.generateActions(...generateAsyncActions('inboxMentionsCount'));
  }

  setNavOverride(navOverride, navOverrideProps) {
    return dispatch => {
      dispatch({navOverride, navOverrideProps});
    };
  }

  clearNavOverride() {
    return dispatch => {
      dispatch();
    };
  }

  inboxMentionsCount() {
    return dispatch => {
      dispatch();
      return MailSource.fetchInboxMentions().then(
        this.inboxMentionsCountSuccess,
        this.inboxMentionsCountError
      );
    };
  }
}

export default alt.createActions(NavActions);
